import Footer from "../../components/Footer/Footer";
import PageHeader from "../../components/TopHeader/PageHeader";
import {
  Container,
} from "./DeviationPageStyle";
import Seo from "../../components/Seo";
import requiredAuth from "../../components/requiredAuth";
import DeviationComponent from '../../components/Map/DeviationComponent';

function ResearchPage() {
  return (
    <Container>
      <Seo title="상세분석" />
      <div style={{ maxWidth: "1300px", margin: "0 auto" }}>
      <PageHeader title="상세 분석" />
      </div>
      <div style={{ margin: "40px 0 80px" }}>
        <DeviationComponent/>
      </div>
      <Footer />
    </Container>
  );
}

export default requiredAuth(ResearchPage);
